import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import ReceiptTemplate from "../InvoiceComp/ReceiptTemplate";
import pdfMake from "pdfmake/build/pdfmake.js";
import ReceiptTemplate_MSA from "../InvoiceComp/ReceiptTemplate_MSA";
import { isITUser } from "util/roles";

const ReceiptModel = (props) => {
	const [PDFDoc, setPDFDoc] = useState(null);
	const resetPreview = props.resetPreview;
	const initForm = props.initForm;
	const receipt = props.selectedReceipt;

	const receiptNo = props.selectedReceipt.receipt?.receiptNo || props.selectedReceipt.receipt?.receipt_no || "-";
	const invoiceObj = props.selectedReceipt.invoice;
	const isMSA = Array.isArray(invoiceObj)
		? invoiceObj[0]?.operation_status === 2
		: invoiceObj?.operation_status === 2;
	const isMSAReceipt = isMSA;

	// Get invoice_no for PDF rendering (no forcePaymentDate for preview)
	const invoiceNo = Array.isArray(invoiceObj)
		? invoiceObj[0]?.invoice_no
		: invoiceObj?.invoice_no;

	/**
	 * Download PDF document
	 * @returns PDF document
	 */
	const downloadPDF = () => {
		if (PDFDoc == null) return;

		if (PDFDoc?.type === "blob" && PDFDoc?.blob instanceof Blob) {
			const blobUrl = URL.createObjectURL(PDFDoc.blob);
			const anchor = document.createElement("a");
			anchor.href = blobUrl;
			anchor.download = PDFDoc.fileName || `${receiptNo}.pdf`;
			document.body.appendChild(anchor);
			anchor.click();
			document.body.removeChild(anchor);
			URL.revokeObjectURL(blobUrl);
			return;
		}

		pdfMake.createPdf(PDFDoc).download(`${receiptNo}.pdf`);
	};

	return (
		<div>
			{/* Header */}
			<Row>
				<Col md="10">
					<h5>{receiptNo}</h5>
				</Col>
				<Col md="2">
					<span
						className="glyphicon glyphicon-chevron-right"
						id="close-preview"
						onClick={resetPreview}
					></span>
				</Col>
			</Row>

			{/* Receipt preview - no forcePaymentDate, uses existing payment date from DB */}
			<Row>
				{isMSAReceipt && invoiceNo ? (
					<ReceiptTemplate_MSA
						invoiceNo={invoiceNo}
						receipt={receipt}
						setPDFDoc={setPDFDoc}
					/>
				) : (
					<ReceiptTemplate
						invoiceNo={invoiceNo}
						receipt={receipt}
						setPDFDoc={setPDFDoc}
					/>
				)}
			</Row>

			{/* Buttons container */}
			<Row style={{ textAlign: "center" }}>
				{isITUser(props.userRoles) && (
					<Button
						variant="warning"
						className="receipt-preview-btn"
						onClick={() => {
							initForm({ data: receipt });
						}}
					>
						Edit
					</Button>
				)}
				<Button
					variant="primary"
					className="receipt-preview-btn"
					onClick={downloadPDF}
				>
					Download
				</Button>
			</Row>
		</div>
	);
};

export default ReceiptModel;
